import type { DataExportResponse } from '@/lib/api/apiTypes';
import { useAuth } from '@/lib/auth/auth';
import { useMutation } from '@tanstack/react-query';

export function useDataExport() {
  const request = useAuth((state) => state.request);

  return useMutation({
    mutationFn: () => request<DataExportResponse>('/me/export'),
  });
}
